import type { ContentRegistry } from '../content/registry';
import type { EraDef } from '../content/types';
import type { SaveData } from '../meta/save';

export interface MenuRunSetup {
  startEra: number;
  paradox: number;
  players: number;
}

/** Era indices that are both implemented and unlocked as Temporal Anchors. */
export function availableStartEras(save: SaveData, reg: ContentRegistry): number[] {
  const maxStart = Math.max(0, ...save.anchors.map((era) => era + 1));
  return reg.eras.filter((era) => era.implemented && era.index <= maxStart).map((era) => era.index);
}

/** Clamp a saved menu selection defensively as progression/content changes. */
export function normalizeRunSetup(save: SaveData, reg: ContentRegistry): MenuRunSetup {
  const starts = availableStartEras(save, reg);
  const startEra = starts.includes(save.runSetup.startEra) ? save.runSetup.startEra : 0;
  return {
    startEra,
    paradox: Math.max(0, Math.min(save.paradoxUnlocked, Math.floor(save.runSetup.paradox))),
    players: Math.max(1, Math.min(4, Math.floor(save.runSetup.players))),
  };
}

/** Highest chronological era the player has reached or anchored. */
export function discoveredThrough(save: SaveData): number {
  return Math.max(0, save.stats.bestEra, ...save.anchors.map((era) => era + 1));
}

/** Future content is intentionally never disclosed, even by malformed saves. */
export function isEraDiscovered(save: SaveData, era: EraDef): boolean {
  return era.implemented && era.index <= discoveredThrough(save);
}
